module.exports = __webpack_public_path__ + "static/media/menu-grupos.9eef2332.svg";